module.exports = __webpack_public_path__ + "img/invoice-de-male-sl.a790d8d3.png";